import React, { useEffect, useState } from "react";

import { API, graphqlOperation } from "aws-amplify";
import { createAssetType } from "../../../graphql/mutations";

import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  MenuItem,
  TextField as MuiTextField,
} from "@material-ui/core";

import { Button, useCreateSuggestionContext, useNotify } from "react-admin";

import { CancelIcon, SaveIcon } from "../../../components/common/iconography";
import { logError } from "../../../utils/appUtils";

export const AssetTypeCreateDialog = ({
  areas,
  assets,
  setAssets,
  setSelectedAsset,
  ...props
}) => {
  const notify = useNotify();
  const { filter, onCancel, onCreate } = useCreateSuggestionContext();
  const [name, setName] = useState(filter || "");
  const [maxBookings, setMaxBookings] = useState();
  const [area, setArea] = useState("");
  const [newlyCreatedAsset, setNewlyCreatedAsset] = useState(null);

  // Ensure `onCreate(newAsset)` is called only after assets are updated
  useEffect(() => {
    if (newlyCreatedAsset) {
      onCreate(newlyCreatedAsset);
      setNewlyCreatedAsset(null); // Reset state to prevent duplicate calls
      setName("");
      setMaxBookings(1);
    }
  }, [newlyCreatedAsset, onCreate]);

  const handleSubmit = async (event) => {
    event.preventDefault();

    try {
      debugger;
      const assetInput = {
        reloadYardId: window.appUser.reloadYardId,
        groups: window.appUser.groups,
        active: "true",
        areaId: area?.id,
        name: name,
        maxConcurrentBookings: maxBookings,
      };

      const response = await API.graphql(
        graphqlOperation(createAssetType, { input: assetInput })
      );

      const newAsset = response.data.createAssetType;
      const updatedAssets = assets ? [...assets, newAsset] : [newAsset];

      // window.appUser.reloadYard.assets = { items: updatedAssets };
      setAssets(updatedAssets);
      setSelectedAsset(newAsset);

      // Set newly created asset and trigger `useEffect` to call `onCreate`
      setNewlyCreatedAsset(newAsset);
    } catch (error) {
      logError("assetTypes:AssetTypeCreateDialog:handleSubmit", error, notify);
    }
  };

  return (
    <Dialog open onClose={onCancel}>
      <DialogTitle>Create New Asset</DialogTitle>
      <form onSubmit={handleSubmit}>
        <DialogContent>
          <Grid container spacing={1}>
            <Grid item xs={12} md={6}>
              <MuiTextField
                label="Resource Name"
                variant="outlined"
                margin="dense"
                value={name}
                onChange={(event) => setName(event.target.value)}
                autoFocus
                required
                fullWidth
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <MuiTextField
                type="number"
                label="Max. Bookings"
                variant="outlined"
                margin="dense"
                value={maxBookings}
                inputProps={{ min: 1 }}
                // disabled={saving}
                required
                fullWidth
                onChange={(event) =>
                  setMaxBookings(parseInt(event.target.value, 10) || 1)
                }
              />
            </Grid>
            <Grid item xs={6}>
              <MuiTextField
                select
                name="areaId"
                label="Area"
                id="areaId"
                margin="dense"
                variant="outlined"
                fullWidth
                resettable
                value={area || ""}
                onChange={(event) => setArea(event.target.value)}
              >
                <MenuItem key="area.id" value="area.id">
                  &nbsp;
                </MenuItem>
                {areas.map((option) => (
                  <MenuItem key={option.id} value={option.id}>
                    {option.name}
                  </MenuItem>
                ))}
              </MuiTextField>
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button label="Cancel" color="default" onClick={onCancel}>
            <CancelIcon />
          </Button>
          <Button label="Save" type="submit">
            <SaveIcon />
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};
